import { partyBrands } from './config.js';
let whiteLabelingUIData = null;

export const getColor = () => {
    if (!whiteLabelingUIData) {
        whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
    }
    if (whiteLabelingUIData && whiteLabelingUIData.color) {
        return whiteLabelingUIData.color;
    } else {
        console.log("Default colors are getting used!")
        return "#e8480d"
    }
} 

export const getTextColor = () => {
    if (!whiteLabelingUIData) {
        whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
    }
    if (whiteLabelingUIData && whiteLabelingUIData.textColor) {
        return whiteLabelingUIData.textColor;
    } else {
        return "#ffffff"
    }
}  

export const getDarkTextColor = () => {
    if (!whiteLabelingUIData) {
        whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
    }
    if (whiteLabelingUIData && whiteLabelingUIData.darkTextColor) {
        return whiteLabelingUIData.darkTextColor;
    } else {
        return "#000000"
    }
} 

export const getHoverColor = () => {
    if (!whiteLabelingUIData) {
        whiteLabelingUIData = localStorage.getItem("whiteLabelUIData") ? JSON.parse(localStorage.getItem("whiteLabelUIData")) : null;
    }
    if (whiteLabelingUIData && whiteLabelingUIData.hoverColor) {
        return whiteLabelingUIData.hoverColor;
    } else {
        return "rgba(232, 73, 12, .2)"
    }
} 

export const getImage = (path, fileType) => {
    if(path === "/images/pokerQuiz/"){
        if(partyBrands.includes(localStorage.getItem("loggedInType"))){
            return path + "PartyPoker" + fileType;
        } else{
            return path + "NonPartyLables" + fileType;
        }
    }
    else if (localStorage.getItem("loggedInType") === "Brand" && localStorage.getItem("brandLogin") && JSON.parse(localStorage.getItem("brandLogin")).brand){
        return path + JSON.parse(localStorage.getItem("brandLogin")).brand.toLowerCase() + fileType;
    } else if (localStorage.getItem('loggedInType') == null || (["PartyPoker","PPIT","PARTYONCA","PARTYSE","PARTYDK","PPDE"].includes(localStorage.getItem("loggedInType")))){
        return path + 'PartyPoker' + fileType;
    } else {
        return path + localStorage.getItem("loggedInType") + fileType;
    }
}


/** WEBPACK FOOTER **
 ** ./src/common/ThemeService.js
 **/